import styles from "./index.module.scss";
import { CollectSvg, CollectedSvg } from "@/assets/icons";
import SvgButton from "../svg-button";
import { CollectStatus } from "@/constants";
import { useTranslation } from "react-i18next";
import Tooltip from "../tooltip";
import { useCommonStore } from "@/stores";
import { toast } from "react-toastify";

const CollectButton = () => {
  const { t } = useTranslation();

  const task = useCommonStore(state => state.task);
  const collectLoading = useCommonStore(state => state.collectLoading);
  const collect = useCommonStore(state => state.collect);

  const handleCollect = async () => {
    const finalCollectStatus = await collect();
    toast(finalCollectStatus === CollectStatus.Collected ? `👌 ${t("collect_success")}` : t("uncollect_success"));
  }

  return (
    <SvgButton
      className={styles["custom_svg_button"]}
      disabled={collectLoading}
      onClick={handleCollect}
    >
      {task?.collectStatus === CollectStatus.Collected ? (
        <CollectedSvg></CollectedSvg>
      ) : (
        <CollectSvg></CollectSvg>
      )}

      <Tooltip
        content={task?.collectStatus === CollectStatus.Collected ? t("uncollect_tip") : t("collect_tip")}
        placement="left"
        arrow={false}
      ></Tooltip>
    </SvgButton>
  )
}

export default CollectButton;